export default "__VITE_ASSET__mjynop8t__"